<div
  #filterByDatesAndOrder
  class="common-dropdown-container">
  <span-tooltip
    class="common-table-cell__title-text-label"
    [text]="filterByDates.label">
  </span-tooltip>
  <div>
    <button
      class="common-button__filter-order-button"
      aria-haspopup="dialog"
      [attr.aria-expanded]="filterByDates.showPopOver "
      [attr.aria-controls]="'filterSearch-' + filterByDates.id"
      aria-label="seleccionar un filtro de fechar"
      (click)="toggleFilter($event)">
      <i aria-hidden="true" class="lf-icon-filter-1 common-icon__md"
        ngClass="{{dateFilter || item.hasfilter ? 'common-button__filter-order-button--active lf-icon-filter-applied' : 'lf-icon-filter-1'}}">
      </i>
    </button>
    <p-popover
      [id]="'filterSearch-' + filterByDates.id" styleClass="common-dropdown-overlay__dates-container"
      (onShow)="filterByDates.showPopOver = true"
      (onHide)="filterByDates.showPopOver = false">
      <from-to-calendar
        [fromSave]="item.fromDate"
        [toSave]="item.toDate"
        (changeCalendar)="onChangeCalendar($event)"
        [(resetDates)]="resetDates">
      </from-to-calendar>
    </p-popover>
  </div>
  @if (item?.filterOrder) {
    <button
      class="common-button__filter-order-button"
    [ngClass]="{
      'common-button__filter-order-button--active': filterOrder === item?.filterOrder
    }"
      (click)="orderColumn()">
      <i aria-hidden="true" class="common-icon__md"
        ngClass="{{filterOrder === item?.filterOrder && !order ? 'lf-icon-arrow-up' : 'lf-icon-arrow-down'}}">
      </i>
    </button>
  }
</div>
